export const OPEN_BUTTON_ID = "add-widgets-to-dashboard";

export const DASHBOARD_GRID_ROW_HEIGHT = 400;

export const DASHBOARD_GRID_ROW_MIN_HEIGHT = 150;
